module.exports = __webpack_public_path__ + "img/DESIGN_DT.91fc7935.png";